import axios from 'axios';
import { executeCaptcha } from '../captcha';
import { formElement, hideFormState, showFormState, validateForm } from '../form-validation';

const postUrl = '/30let';

/** @returns {Promise<Response>} */
const sendForm = async () => {
    const formData = new FormData(formElement);

    return axios.post(postUrl, formData);
};

/** @returns {Promise<Response>} */
const sendCaptcha = async () => {
    const formData = new FormData();

    formData.append('check', 'true');
    formData.append('recaptcha_response', formElement.elements.recaptcha_response.value);

    return axios.post(postUrl, formData);
};

/** @param {Event} event */
const processForm = async (event) => {
    event.preventDefault();

    // disable multiple form submiting
    formElement.removeEventListener('submit', processForm);
    formElement.addEventListener('submit', (innerEvent) => innerEvent.preventDefault());

    hideFormState();

    /** @type {HTMLButtonElement} */
    const formSubmitButton = formElement.querySelector('[data-submit]');

    if (formSubmitButton) {
        formSubmitButton.classList.add('form__btn--loading');
    }

    try {
        const captchaResponse = await sendCaptcha();
        if (captchaResponse.data.err !== 'ok') {
            throw new Error('wrong captcha');
        }

        const formResponse = await sendForm();

        if (formResponse.status !== 200) {
            throw new Error(`wrong request url: ${formResponse.url}`);
        }

        showFormState(true);
        executeCaptcha();
    } catch (error) {
        showFormState(false);
        throw new Error(error.message);
    } finally {
        if (formSubmitButton) {
            formSubmitButton.classList.remove('form__btn--loading');
        }

        formElement.remove();
        document.getElementById('section-form').scrollIntoView();

        // enable submiting form after sending
        formElement.addEventListener('submit', processForm);
    }
};

export const form = () => {
    if (!formElement) return;

    validateForm();

    formElement.addEventListener('submit', processForm);
};
